import React, { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { TypographyVariant } from 'components/core';
import { UserMenuOptions } from './user-menu-options';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Styled } from './user-menu.style';

// hooks
import { useBusiness } from 'hooks/business/use-business';

export const UserMenu: React.FC = () => {
  const { data: business } = useBusiness();

  const [showActions, setShowActions] = useState(false);

  const companyName = business?.LegalName || business?.DBA;

  return (
    <Styled.Container
      onClick={() => {
        setShowActions(!showActions);
      }}
      textAlign="right"
      px={2}
    >
      <Styled.GridContainer container alignItems="center">
        <Grid item>
          <Styled.CompanyName variant={TypographyVariant.Body}>
            {companyName}
          </Styled.CompanyName>
        </Grid>

        <Grid item>
          <ArrowDropDownIcon />
        </Grid>
      </Styled.GridContainer>

      {showActions ? <UserMenuOptions setShowActions={setShowActions} /> : null}
    </Styled.Container>
  );
};
